import { useEffect } from 'react'

/**
 * Lightweight hook to update document metadata per route.
 * Updates title, meta description, and canonical URL.
 * Restores previous title on unmount.
 */
export function useDocumentMeta(options: {
  title: string
  description?: string
  canonical?: string
}) {
  useEffect(() => {
    const prevTitle = document.title
    document.title = options.title

    if (options.description) {
      const meta = document.querySelector('meta[name="description"]')
      if (meta) meta.setAttribute('content', options.description)
    }

    if (options.canonical) {
      const link = document.querySelector('link[rel="canonical"]')
      if (link) link.setAttribute('href', options.canonical)
    }

    return () => {
      document.title = prevTitle
    }
  }, [options.title, options.description, options.canonical])
}
